<div class="modals delivery" [class.modals-show]="isModalDeliveryShow" [class.modals-hide]="!isModalDeliveryShow">
  <div class="wrapper">
    <h4 class="text-center">
      Важливо! Від вибору способу доставки залежить видимість наявності на вибраному складі.
    </h4>
    <a class="delivery-select" (click)="showDeliveryList()">Вибір доставки, складу</a>
    <ul *ngIf="delivery && delivery.length > 0"
        class="delivery-list"
        [class.show]="isDeliveryListShow"
    >
      <li
        *ngFor="let item of delivery"
        (click)="setDelivery(item.id)"
      >
        <b>{{item.name}}</b>
        <p [innerHTML]="item.comment"></p>
      </li>
    </ul>
  </div>
</div>

<div class="dark-layer not-hide" [class.modals-show]="isDarkBackgroundNotHide"></div>
